import * as tslib_1 from "tslib";
import { render, html, define, element } from "@pru/pcef-wc-toolkit";
var RICPruBrandingTemplate = function (host) {
    if (host.showBranding) {
        if (host.onPlanner) {
            return html(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        <h1 class=\"ric-pru-branding__text\">\n          MyRock<sup class=\"ric-pru-branding__text service-mark\">SM</sup> for Retirement\n        </h1>\n      "], ["\n        <h1 class=\"ric-pru-branding__text\">\n          MyRock<sup class=\"ric-pru-branding__text service-mark\">SM</sup> for Retirement\n        </h1>\n      "])));
        }
        else {
            return html(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n        <h2 class=\"ric-pru-branding__text\">\n          MyRock<sup class=\"ric-pru-branding__text service-mark\">SM</sup> for Retirement\n        </h2>\n      "], ["\n        <h2 class=\"ric-pru-branding__text\">\n          MyRock<sup class=\"ric-pru-branding__text service-mark\">SM</sup> for Retirement\n        </h2>\n      "])));
        }
    }
    else {
        return html(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject([""], [""])));
    }
};
var ɵ0 = RICPruBrandingTemplate;
var RICPruBrandingElement = {
    showBranding: false,
    onPlanner: false,
    render: render(RICPruBrandingTemplate)
};
define("ric-pru-branding", element(RICPruBrandingElement));
export { RICPruBrandingElement };
export { ɵ0 };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ric-pru-branding.js.map